import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import "./App.css";
import "../../styles/globals.css";
import SignUp from "../signup/Signup";
import LoginPage from "../login/LoginPage";
import VerifyEmail from "../VerifyEmail/VerifyEmail";
import LandingPage from "../Landing Page/LandingPage";
import { AppProvider, useAppContext } from "../../Contexts/AppContext";
import { UserProvider } from "../../Contexts/UserContext";
import Dashboard from "../dashboard/Dashboard";
import OtpPage from "../OTP/Otp";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import ResetPassword from "../ResetPassword/ResetPassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../layout/Layout";
import { DivisionProvider } from "../../Contexts/DivisionContext";
import { CaseProvider } from "../../Contexts/CaseContext";
import { NotificationProvider } from "../../Contexts/NotificationContext";
import EditProfile from "../dashboard/EditProfile";
import ChangeEmail from "../Settings/ChangeEmail";
import ChangePassword from "../Settings/ChangePassword";
import ConfirmEmailChange from "../Settings/VerifyChangeEmail";
import ProfilePage from "../dashboard/ProfilePage";
import VerifyPaymentPage from "../Payment/VerifyPaymentPage";
// import JudgeMeeting from '../Zoom/zoomHost';
import ZoomSession from "../Zoom/zoomSession";
import { useUserContext } from "../../Contexts/UserContext";
import ExternalZoomSession from "../Zoom/externalZoomSession";
import YouTubeEmbed from "../Zoom/liveStream";
import UpcomingCases from "../upcomingCases";
import OngoingSessions from "../ongoingSessions";
import PastRecordings from "../pastRecordings";
import VerifyRulingPayment from "../Payment/VerifyRulingPayment";
import UploadDocument from "../dashboard/UploadDocuments";
import PublicZoomSession from "../Zoom/PublicZoomSession";

const App: React.FC = () => {
	const { isLoggedIn } = useAppContext();
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { userData } = useUserContext();

	return (
		<Router>
			<div>
				<Layout>
					<main className="flex-grow min-h-screen">
						<Routes>
							{!isLoggedIn && (
								<>
									<Route path="/" element={<LandingPage />} />
									<Route path="/login" element={<LoginPage />} />
									<Route path="/register" element={<SignUp />} />
									<Route path="/verify-email" element={<VerifyEmail />} />
									<Route path="/forgot-password" element={<ForgotPassword />} />
									<Route path="/reset-password" element={<ResetPassword />} />
									<Route path="/otp" element={<OtpPage />} />
									<Route
										path="/ext-court-live-session/:id/:title/:email"
										element={<ExternalZoomSession />}
									/>
									<Route
										path="/public-hearing/:id/:title"
										element={<PublicZoomSession />}
									/>
									<Route path="*" element={<Navigate to="/login" />} />
									<Route
										path="/live-stream"
										element={
											<YouTubeEmbed channelId={"UCbU5pRr8xkkbGOtDo4XDCrA"} />
										}
									/>
								</>
							)}
							{isLoggedIn && (
								<>
									<Route path="/" element={<Dashboard />} />
									<Route path="/dashboard/*" element={<Dashboard />} />
									<Route path="*" element={<Navigate to="/" />} />
									<Route path="profile" element={<ProfilePage />} />
									<Route path="/edit-profile" element={<EditProfile />} />
									<Route path="change-email" element={<ChangeEmail />} />
									<Route path="/court-live-session/:id" element={<ZoomSession />} />
									<Route path="change-password" element={<ChangePassword />} />
									<Route
										path="confirm-email-change"
										element={<ConfirmEmailChange />}
									/>
									<Route
										path="/verify-payment"
										element={<VerifyPaymentPage />}
									/>
									<Route
										path="/payment-verify"
										element={<VerifyRulingPayment />}
									/>
									<Route path="/upload-document" element={<UploadDocument />} />
									<Route
										path="/live-stream"
										element={<YouTubeEmbed channelId={"@jonahemmanuel813"} />}
									/>
									<Route
										path="/public-hearing/:id/:title"
										element={<PublicZoomSession />}
									/>
								</>
							)}
							<Route path="/home" element={<LandingPage />} />
							<Route path="/about" element={<LandingPage />} />
							<Route path="/vision" element={<LandingPage />} />
							<Route path="/mission" element={<LandingPage />} />
							<Route path="/services" element={<LandingPage />} />
							<Route path="/upcoming-cases" element={<UpcomingCases />} />
							<Route path="/ongoing-sessions" element={<OngoingSessions />} />
							<Route path="/past-recordings" element={<PastRecordings />} />
						</Routes>
					</main>
				</Layout>
			</div>
		</Router>
	);
};

const AppWithProvider: React.FC = () => {
	return (
		<AppProvider>
			<UserProvider>
				<DivisionProvider>
					<CaseProvider>
						<NotificationProvider>
							<App />
							<ToastContainer />
						</NotificationProvider>
					</CaseProvider>
				</DivisionProvider>
			</UserProvider>
		</AppProvider>
	);
};

export default AppWithProvider;
